export default "__VITE_ASSET__CBNJGlrw__"